import { z } from 'zod';

import type { OutboundRecordReference } from './outbound-record-reference.dto.js';
import { outboundRecordTypeValues } from './outbound-record-reference.dto.js';

export const OutboundRecordTypeSchema = z.enum(outboundRecordTypeValues);

export const OutboundRecordReferenceSchema = z
  .object({
    outboundRecordType: OutboundRecordTypeSchema,
    outboundRecordId: z.uuid(),
  })
  .strict() satisfies z.ZodType<OutboundRecordReference>;
